var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout__height-1240px layout__overflow-hidden"},[_c('iframe',{staticClass:"layout__height-1240px",attrs:{"src":_vm.iframe_src,"width":"100%","height":"100%;","scrolling":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }